import { Vue, i18n, initSentry } from "@/public/utils/customVue";
import App from "./App.vue";
// import router from './router';
import store from "./store/index";
import locale from "iview/src/locale/index";
import {
    InputNumber,
    Modal,
    Tooltip,
    Dropdown,
    Icon,
    DropdownMenu,
    DropdownItem,
    DatePicker,
    Checkbox,
    Radio,
    RadioGroup,
    Slider,
    FormItem,
    Form,
    Row,
    Col,
    Switch,
    Input,
    CheckboxGroup,
    Tabs,
    TabPane,
    Message,
    Button,
    ButtonGroup,
    Scroll,
    Layout,
    Select,
    Option,
    Progress,
    Spin,
    Table,
    TimePicker,
    Upload,
    Page,
    Poptip,
} from "iview";
import VueShepherd from "vue-shepherd";
import { addJs } from "@/public/utils/tool";
import { urls } from "@/public/utils/env.js";
import EDModal from "@/public/components/EDModal/edmodal.vue";
import { SdkApp } from "@/sdk";

initSentry();

const iViewComponent = [
    InputNumber,
    Modal,
    Tooltip,
    Dropdown,
    Icon,
    DropdownMenu,
    DropdownItem,
    Checkbox,
    Radio,
    RadioGroup,
    Slider,
    FormItem,
    FormItem,
    Row,
    Col,
    Input,
    CheckboxGroup,
    Tabs,
    TabPane,
    Button,
    ButtonGroup,
    Scroll,
    Layout,
    Select,
    Option,
    Progress,
    Spin,
    Table,
    Upload,
    Page,
    Poptip,
];
// home using iview component
function toIview18n(path, options) {
    let value = i18n.t(path, options);
    if (value !== null && value !== undefined) {
        return value;
    }
    return "";
}

locale.i18n(toIview18n);

(InputNumber as any).computed.precisionValue = function () {
    let arr = (this.currentValue + "").split(".");
    if (this.precision && arr[1] && this.precision < arr[1].length) return this.currentValue.toFixed(this.precision);
    return this.currentValue;
};
// Vue.use(iView);
iViewComponent.forEach((c) => {
    Vue.component(c.name, c);
});

Vue.component("DatePicker", DatePicker);
Vue.component("TimePicker", TimePicker);
Vue.component("Form", Form);
Vue.component("iSwitch", Switch);
Vue.component("iSelect", Select);
Vue.component("iOption", Option);
Vue.component("iButton", Button);
Vue.component("iCol", Col);
Vue.component("iForm", Form);
Vue.component("iInput", Input);
Vue.component("iProgress", Progress);
Vue.component("iTable", Table);
Vue.component("EDModal", EDModal);

Vue.prototype.EDCONFIG = window.EDCONFIG;
Vue.prototype.$Modal = Modal;
Vue.prototype.$Message = Message;
Vue.prototype.$IVIEW = {
    size: "",
    transfer: "",
    select: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    cell: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    menu: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    tree: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    cascader: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
        itemArrow: "",
        customItemArrow: "",
        itemArrowSize: "",
    },
    colorPicker: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    datePicker: {
        icon: "",
        customIcon: "",
        iconSize: "",
    },
    timePicker: {
        icon: "",
        customIcon: "",
        iconSize: "",
    },
    tabs: {
        closeIcon: "",
        customCloseIcon: "",
        closeIconSize: "",
    },
    modal: {
        maskClosable: "",
    },
};

import "iview/dist/styles/iview.css";
import "@/public/css/globalVar.css";
import "./style/index.css";

import * as vClickOutside from "v-click-outside-x";
import VueLazyload from "vue-lazyload";

Vue.use(vClickOutside);

const loadingImage = require(
    `@/home/assets/img/newPage/recommend/${window.EDCONFIG.DEFAULT_THEME === "dark" ? "img-lazy-loading-dark" : "img-lazy-loading"}.svg`
);
const errorImage = require("@/home/assets/img/newPage/recommend/img-lazy-error.svg");

Vue.use(VueLazyload, {
    loading: loadingImage,
    error: errorImage,
});

import iconSymbol from "@/app/components/Symbol.vue";
import VipIcon from "@/app/components/Common/VipIcon.vue";
//多语言
//iview的语言文件
// import en from 'iview/dist/locale/en-US';
// import zh from 'iview/dist/locale/zh-CN';
// Vue.locale('zh-CN',zh)
// Vue.locale('en-US',en)
// //自己的语言文件
// import lang from "@/lang";
// import VueI18n from "vue-i18n";
// Vue.use(VueI18n);
// // import vClickOutside from 'v-click-outside'
// // Vue.use(vClickOutside);
// let combineLang={CN:Object.assign(lang.CN,zh),EN:Object.assign(lang.EN, en)}
// //vue I18n 多语言
// const i18n = new VueI18n({
// 	locale: "CN", // set locale
// 	messages: combineLang, // set locale messages
// 	silentTranslationWarn: true
// });

Vue.component("iconSymbol", iconSymbol);
Vue.component("VipIcon", VipIcon);
Vue.config.productionTip = false;
document.oncontextmenu = () => {
    return false;
};
// window.onunload = ()=>{
//   window.name = '';
// }
// document.addEventListener('keydown',(e)=>{
//   if(e.keyCode === 122){
//     e.preventDefault();
//   }
// })
import TransferDom from "@/public/utils/transfer-dom.js";
import TextOverflowWithTippy from "@/public/utils/textoverflow-with-tippy.js";
Vue.directive("transfer-dom", TransferDom);
Vue.directive("textoverflow-with-tippy", TextOverflowWithTippy);
import "shepherd.js/dist/css/shepherd.css";
Vue.use(VueShepherd);
declare module "vue/types/vue" {
    interface Vue {
        $checkAuth: any;
        $shepherd: any;
        $pcTrack: any;
        $track: any;
        $bus: any;
        $edApi: any;
        $edMessage: any;
        $edModal: any;
        fuser: any;
        lang: any;
        urls: any;
        internal: any;
        appVersion: any;
        $changLang: any;
        $openBuyPage: Function;
        isPlugin: any;
        isBoard: any;
        isWorkwx: any;
        sensors: {
            quick: Function;
            track: Function;
            registerPage: Function;
        };
        isPrivate: boolean;
        isTeamsApp: boolean;
        appEnv: string;
        isFullCouldSpace: boolean;
        OSSAccessKeyId: string;
        arguments: any; // 避免模板中类似 @handleClicks="handleClicks(...arguments) 的使用导致的ts报错
        EDCONFIG: any;
        sdkApp: SdkApp;
        isDarkTheme: () => boolean;
        isTestEnv: boolean;
        utm_term: string;
        appPid: number;
    }
}
let isInclowdz = sessionStorage.getItem("isInclowdz");
Object.defineProperties(Vue.prototype, {
    isInclowdz: {
        get: () => {
            return isInclowdz == "1";
        },
    },
});

/**
 * SDK部署时，sdkApp对象用于跟主站进行消息通信
 */
const sdkApp = new SdkApp("*", { timeout: 3 * 60 * 1000 });
Object.defineProperties(Vue.prototype, {
    sdkApp: {
        get: () => {
            return sdkApp;
        },
    },
});

window["app"] = { $v_: 1 };

Vue.config.errorHandler = function (err, vm, info) {
    if (err && err?.name?.toLocaleLowerCase() === "quotaexceedederror") {
        // 处理 local storage 超出限制报错
        let curFileID = vm.$store.state.ui.fileID;
        if (curFileID) {
            const nowCache = localStorage.getItem("CacheRenderLibrary");
            let nowCacheArr = JSON.parse(nowCache);
            nowCacheArr = nowCacheArr.filter((v) => v.fileID === curFileID);
            // 只保留当前文件的符号库缓存数据
            localStorage.setItem("CacheRenderLibrary", JSON.stringify(nowCacheArr));
        }
    } else {
        /**
         * function globalHandleError (err, vm, info) {
            if (config.errorHandler) {
                try {
                return config.errorHandler.call(null, err, vm, info)
                } catch (e) {
                // if the user intentionally throws the original error in the handler,
                // do not log it twice
                if (e !== err) {
                    logError(e, null, 'config.errorHandler');
                }
                }
            }
            logError(err, vm, info);
            }
            // 其他错误仍需要将 err throw 出去
         */
        throw err;
    }
};

function newApp() {
    window["app"] = new Vue({
        // router,
        store,
        i18n,
        render: (h) => h(App),
    }).$mount("#app");
}

if (typeof window["$edAuth"] === undefined && !window.EDCONFIG.IS_SDK) {
    let authSrc = `${urls.accountUrl}/utils/edauth.js`;
    addJs(authSrc, () => {
        newApp();
    });
} else {
    newApp();
}
